import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-docs",
  "use": "icon-docs-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-docs\"><g fill=\"currentColor\"><path d=\"M12 20l-1-1h2l-1 1zm0-17l1-1v19l-1-1-1 1V2l1 1zm-1-1h2v19h-2V2zM4.5 6h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm0 4h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm11-4h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm0 4h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z\" /><path d=\"M13.032 19.005c1.744.025 4.718.279 8.968.762V4H2v15.766c4.259-.484 7.239-.738 8.987-.762.375-.005.721.084 1.022.243.302-.16.649-.248 1.023-.243zM2 2h20a2 2 0 0 1 2 2.001v15.765a2 2 0 0 1-2.226 1.99c-4.187-.477-7.11-.726-8.77-.75-.335-.004.106.994-1.004.994s-.657-.998-.985-.994c-1.664.023-4.593.273-8.79.75A2 2 0 0 1 0 19.765V4.002A2 2 0 0 1 2 2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-docs.svg
// module id = 872
// module chunks = 74